import { Component, OnInit,ViewEncapsulation, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.sass']
})
export class TermsComponent implements OnInit {
  constructor(private loadingScreenService :LoadingScreenService,private services: Service,private global:GlobalService,public matDialogRef:MatDialogRef<TermsComponent>,@Inject(MAT_DIALOG_DATA) public data: any, private router:Router) { }
  ngOnInit() {
  }
  public close(){;
    this.matDialogRef.close('cancel');
  }
}
